module.exports = __webpack_public_path__ + "img/wx-share-coupon.b5096b1a.png";